import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { HeatmapAnalysisOutput } from 'libs/end-to-end/src/heatmap-analysis';
import { HeatmapAnalysisOutputFinalFile } from 'libs/end-to-end/src/heatmap-analysis';

export const HeatmapAnalysisCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'heatmap',
  isDataQueuingAllowed: true,
  outputFileName: HeatmapAnalysisOutputFinalFile,
  outputSchema: HeatmapAnalysisOutput,
  resolveFocusArea: () => null,
  resolveFilters: (request) => {
    if (request.customVizId !== 'heatmap') {
      throw new Error('Invalid custom viz ID');
    }
    return request.inputs.extras.filters;
  },
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  eventProperties: (request) => {
    if (request.customVizId !== 'heatmap') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      Filters: request.inputs.extras.filters,
      'Selected Dimensions': [request.inputs.extras.dimension],
      'Selected Metrics': [],
      'Selected Focus Areas': [],
    };
  },
  getUrlPath: () => 'explore',
};
